'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('body', {
      template: '<ui-view />'
    });
}



// WEBPACK FOOTER //
// ./client/app/body/body.routes.js